export class CalculationHelpers {
    public static transformNumberIntoPriceFloat(value: number): number {
        return value / 100;
    }

    public static transformStringIntoFloat(value: string): number {
        return parseInt(value) / 100;
    }

    public static priceWithComma(price: number): string {
        let value = price.toString();
        let length = value.length;
        if (length < 3) {
            value = this.addLeadingZeros(value, 3);
            length = value.length;
        }
        return value.substring(0, length - 2) + ',' + value.substring(length - 2);
    }

    public static convertStringToFloat(stringValue: string): number {
        let replacedString = stringValue.replace(/\./g, '');
        replacedString = replacedString.replace(/,/g, '.');
        return parseFloat(replacedString);
    }

    public static convertFloatToString(floatValue: number): string {
        const roundedFloatValue = this.round2Digits(floatValue);
        let stringValue = roundedFloatValue.toFixed(2);
        if (stringValue === 'NaN') {
            stringValue = ' - ';
        }
        return stringValue.replace('.', ',');
    }

    public static multiplyFloats(a: number, b: number): number {
        const tensForA = Math.pow(10, String(a).length - String(a).indexOf('.') - 1),
            tensForB = Math.pow(10, String(b).length - String(b).indexOf('.') - 1);
        return (a * tensForA * (b * tensForB)) / (tensForA * tensForB);
    }

    public static round2Digits(floatValue: number): number {
        return Math.round(this.multiplyFloats(floatValue, 100)) / 100;
    }

    private static addLeadingZeros(str: string, targetLength: number): string {
        return str.padStart(targetLength, '0');
    }
}

export const calculateFraction = (counter: number, denominator: number) => (denominator ? counter / denominator : 0);

export const calculatePercentage = (counter: number, denominator: number) => calculateFraction(counter, denominator) * 100;
